module.exports = __webpack_public_path__ + "static/media/tripura.29a9756e.png";